import httpService from '@/services/core/http.service';

class SensorsWatchListService {
    route = 'sensor-watch-list';

    getAll = () => httpService.get(this.route);
    create = item => httpService.post(this.route, item);
    delete = id => httpService.delete(`${this.route}/${id}`);
    assign = (sensorId, watchListIds) => httpService.put(`${this.route}/assign?sensorId=${sensorId}`, watchListIds);
}

export default new SensorsWatchListService();
